import Artpunk from './img/artpunk.jpg';
import Athenadexfi from './img/Athenadexfi.jpg';
import Barc from './img/Barclays-PLC-stock-price.jpg';
import BrainTumor from './img/brain-tumour.JPG';
import Dukaanni from './img/dukaanni.png';
import Pumpfun from './img/pumpfun.png';
import Membula from './img/membula.png';
import Ordibets from './img/ordibets.png';
import Passerine from './img/passerine.png';
import Pdf from './img/pdf-ask-answer.jpg';
import RecursiveRune from './img/Recursive-Rune.jpg';
import RewardStaking from './img/reward-staking.png';
import JossAI from './img/JossAI.JPG';
import Tennis from './img/tennis.gif';
import Translation from './img/translation.jpg';
import Vkingplays from './img/vkingplays.jpg';
import WizardTech from './img/wizard-tech.png';
import Jackpot from './img/jackpot.png';
import Bitcoin from './img/bitcoin.JPG';
import RoadDamage from './img/Road-damage.JPG';
import Similarity from './img/similarity.JPG';
import Vehicle from './img/vehicle.gif';
import TableTennis from './img/table.gif';
import Dating from './img/series-chatbot.jpeg';
import Bitmap from './img/bitmap.png';
import ArbitragyBot from './img/arbitragyBot.png';
import CopytradingBot from './img/copyTrading.png';
import VolumeBot from './img/volumeBot.png';
import PumpfunBundler from './img/pumpfunBundler.png';

const header = {
  homepage: 'https://www.devcutup.com/',
  title: 'Janus',
}

const about = {
  name: 'Janus Dev',
  role: 'Blockchain | Fullstack',
  description:
    '',
  resume: '',
  social: {
    gmail: "mailto:devcutup@gmail.com", 
    github: 'https://github.com/cutupdev',
    // linkedin: 'https://linkedin.com',
    whatsapp: 'https://wa.me/13137423660',
    telegram: 'https://t.me/DevCutup',
    twitter: 'https://twitter.com/devcutup',
    instagram: 'https://www.instagram.com/januscutup/',
    youtube: 'https://www.youtube.com/@Janus-dev',
  },
}

const projects = [
  {
    name: 'Athena Dexfi',
    image: Athenadexfi,
    description:
      'Smart Trading Platform where big whales invest their money Launchpad platform',
    stack: ['Solidity', 'Web3', 'TypeScript'],
    code: 'https://github.com/cutupdev/Athena-Dexfi',
    online: 'https://athenadexfi.io/',
    preview: 'https://athenadexfi.io/'
  },
  
  {
    name: 'Pumpfun',
    image: Pumpfun,
    description:
      'Pump.fun fork and additional functionalities on Solana',
    stack: ['Solana', 'Rust', 'Anchor', 'liquidity', 'Node.js', 'React.js', 'MongoDB'],
    code: 'https://github.com/cutupdev/Pumpfun-SC',
    online: 'https://app.ape.lol/',
    preview: ''
  },
  {
    name: 'Volume bot',
    image: VolumeBot,
    description:
      'Volume bot to increase token volume. Distribution of SOL to multiple wallets and execute automated buy and sell transactions on the Solana Raydium/Pumpfun.',
    stack: ['Solana', 'Raydium', 'Pumpfun', 'Typescript'],
    code: 'https://github.com/cutupdev/Solana-Raydium-Volume-Bot',
    online: 'https://github.com/cutupdev/Solana-Raydium-Volume-Bot',
    preview: ''
  },
  {
    name: 'Pumpfun bundler',
    image: PumpfunBundler,
    description:
      'Bundler for pump.fun, enabling to launch a token with 20 different wallets, can bundle 20 buy transactions for pump.fun.',
    stack: ['Pumpfun', 'Bundler', 'Bot', 'Typescript'],
    code: 'https://github.com/cutupdev/Solana-Pumpfun-Bundler',
    online: 'https://github.com/cutupdev/Solana-Pumpfun-Bundler',
    preview: ''
  },
  {
    name: 'Copy trading bot',
    image: CopytradingBot,
    description:
      'Copytrade target wallet activity based on analysis of profitability in few seconds.',
    stack: ['Copytrading', 'Wallet tracking', 'Pumpfun', 'Raydium'],
    code: 'https://github.com/cutupdev/Solana-Copytrading-bot',
    online: 'https://github.com/cutupdev/Solana-Copytrading-bot',
    preview: ''
  },
  {
    name: 'Arbitragy bot',
    image: ArbitragyBot,
    description:
      'Solana arbitragy bot on several dex platforms such as raydium and meteora.',
    stack: ['Arbitragy', 'Raydium', 'Meteora', 'Solana'],
    code: 'https://github.com/cutupdev/Solana-Arbitrage-Bot',
    online: 'https://github.com/cutupdev/Solana-Arbitrage-Bot',
    preview: ''
  },
  {
    name: 'Clothes similarity app',
    image: Similarity,
    description:
      'Clothes similarity app, clients can order styles what they want',
    stack: ['Python', 'tensorflow', 'encode', 'similarity-search'],
    code: 'https://github.com/cutupdev/Clothes-Similarity-Comparison/',
    online: 'https://ioannotator.com/image-similarity-search/',
    preview: ''
  },
  {
    name: 'Bitmap community',
    image: Bitmap,
    description:
      'Ordinal inscription service',
    stack: ['Bitcoin', 'Ordinals', 'Typescript'],
    code: 'https://github.com/cutupdev/bitmap-community',
    online: 'https://bitmap.community/',
    preview: ''
  },
  {
    name: 'PDF Question-Answer System',
    image: Pdf,
    description:
      'PDF upload, analyze. When clients ask about the content, search suitable content and offer result',
    stack: ['Python', 'OpenAI', 'Embedding'],
    code: 'https://github.com/cutupdev/pdf-ask-system',
    online: 'https://sharly.ai/',
    preview: ''
  },
  {
    name: 'Casino Game Tool',
    image: Vkingplays,
    description:
      'Several Casino Game Tool by payment using credit card',
    stack: ['Javascript', 'React.js', 'Node.js', 'MongoDB'],
    code: 'https://github.com/cutupdev/Vkingplays',
    online: 'https://uat.vkingplays.com/',
    preview: ''
  },
  {
    name: 'AI dating app',
    image: Dating,
    description:
      'Clients can meet(generate) virtual partner then have a chatting',
    stack: ['Langchain', 'OpenAI', 'stableDifussion'],
    code: 'https://github.com/cutupdev/AI-dating',
    online: 'https://www.harmonitechteam.com/',
    preview: ''
  },
  {
    name: 'Bitcoin wallet toolkit',
    image: Membula,
    description:
      'This project offers various useful functionalities for bitcoin wallet',
    stack: ['Javascript', 'Bitcoin', 'Ordinals', 'Runes'],
    code: 'https://github.com/cutupdev/btc-wallet-support-toolkit',
    online: 'https://www.membula.io/',
    preview: ''
  },
  {
    name: 'Jackpot Game',
    image: Jackpot,
    description:
      'Jackpot Game on Solana',
    stack: ['Solana', 'P2E Game', 'Next.js', 'MongoDB'],
    code: 'https://github.com/cutupdev/Jackpot-Solana-Frontend',
    online: 'https://wheel.mctoken.xyz/',
    preview: ''
  },
  {
    name: 'Barclays PLC stock price prediction',
    image: Barc,
    description:
      'Barclays PLC stock price prediction by LSTM. Data collection using Python yfinance and flask for API.',
    stack: ['Tensorflow', 'LSTM', 'Flask', 'yfinance'],
    code: 'https://github.com/cutupdev/Barclays-PLC-stock-price-prediction',
    online: ' https://20aa-45-8-22-59.ngrok-free.app',
    preview: ''
  },
  {
    name: 'Recursive Rune',
    image: RecursiveRune,
    description:
      'Implemented Recursive Rune. This Rune Parent Inscription has 4 child inscriptions. Each Child Inscription contains 1k Harmonitech Runes',
    stack: ['Bitcoin', 'Recursive Ordinal', 'Taproot'],
    code: 'https://mempool.space/testnet/tx/f984a855960a203395facb062f173700143f3d19e48b6918bde5dc29f445a3fe',
    online: 'https://with18testnet.ordstuff.info/inscription/ea4303aaa2c7939931a2ba129c9fc915d1905d441f2a74b6cd694c71665c7682i0',
    preview: ''
  },
  {
    name: 'Bitcoin price prediction',
    image: Bitcoin,
    description:
      'Bitcoin price prediction project using LSTM',
    stack: ['Python', 'Keras', 'LSTM', 'Binance API'],
    code: 'https://github.com/cutupdev/Pumpfun-SC',
    online: 'https://github.com/cutupdev/Bitcoin-Price-Prediction-Model-Deep-Research-in-LSTM-GRU/',
    preview: ''
  },
  {
    name: 'Rewards Staking',
    image: RewardStaking,
    description:
      'Rewards Staking for Kingdom of Dwarves NFT collections on Solana Chain',
    stack: ['Rust', 'TypeScript'],
    code: 'https://github.com/cutupdev/Kod-Reward-Staking',
    online: 'https://anybodies.io/c/kod',
    preview: ''
  },
  {
    name: 'Wizard-Tech',
    image: WizardTech,
    description:
      'Offering customized emotional advice based on analysis of emotion based on words and face',
    stack: ['Python', 'Django', 'HuggingFace', 'BERT', 'CNN'],
    code: 'https://github.com/cutupdev/Wizard-Tech',
    online: 'https://wizardtech.carrd.co/',
    preview: ''
  },
  // {
  //   name: 'Dukaanni',
  //   image: Dukaanni,
  //   description:
  //     'Ecommerce website',
  //   stack: ['React.js', 'Node.js', 'MongoDB', 'Stripe'],
  //   code: 'https://github.com/cutupdev/Dukaanni',
  //   online: 'https://dukaanni.netlify.app',
  //   preview: ''
  // },
  {
    name: 'Vehicle counting project',
    image: Vehicle,
    description:
      'Real time vehicle counting',
    stack: ['Python', 'YOLO'],
    code: 'https://github.com/cutupdev/Vehicle-Real-Time-Counting-YOLO/',
    online: 'https://www.harmonitechteam.com/',
    preview: ''
  },
  // {
  //   name: 'Ordibets',
  //   image: Ordibets,
  //   description:
  //     'Cryptocurrency deposit site',
  //   stack: ['Next.js', 'Web3', 'MongoDB', 'Deposit'],
  //   code: 'https://github.com/cutupdev/Ordibets',
  //   online: 'https://ordibets.netlify.app/',
  //   preview: ''
  // },
  {
    name: 'Artpunk',
    image: Artpunk,
    description:
      'NFT staking / unstaking on Solana chain',
    stack: ['Smart Contract', 'Web3', 'Rust', 'Typescript'],
    code: 'https://github.com/cutupdev/artpunk-unstaking',
    online: 'https://artpunks.fun/',
    preview: ''
  },
  {
    name: 'English-Fula Translation',
    image: Translation,
    description:
      'English-Fula Translation System using Marian',
    stack: ['Python', 'LLM', 'Marian NMT'],
    code: 'https://github.com/cutupdev/fula-to-english-translation',
    online: 'https://www.stars21.com/translator/english/fula/',
    preview: ''
  },
  {
    name: 'Tennis Ball Tracking',
    image: Tennis,
    description:
      "Tennis ball tracking app for player's game analysis",
    stack: ['Python', 'YOLO', 'Flask'],
    code: 'https://github.com/cutupdev/Real-Time-Tennis-Ball-Tracking-in-Bad-Angle',
    online: 'https://swing.tennis/',
    preview: ''
  },
  // {
  //   name: 'Passerine',
  //   image: Passerine,
  //   description:
  //     'Fitness support site',
  //   stack: ['Next.js', 'MongoDB', 'Fitness'],
  //   code: 'https://github.com/cutupdev/Passerine',
  //   online: 'https://passerine.netlify.app/',
  //   preview: ''
  // },
  {
    name: 'Brain Tumor',
    image: BrainTumor,
    description:
      'Brain Tumor segmentaion, trained by BraTS2020 datasets',
    stack: ['Tensorflow', 'Encoder', 'Decoder'],
    code: 'https://github.com/cutupdev/Brain-Tumors-Segmentation-using-Encoder-Decoder',
    online: 'https://www.harmonitechteam.com/',
    preview: ''
  },
  {
    name: 'Road Damage Detector',
    image: RoadDamage,
    description:
      'Road Damage Detector app from photo',
    stack: ['Python', 'Image processing', 'YOLO'],
    code: 'https://github.com/cutupdev/Road-Damage-Detection/',
    online: 'https://www.harmonitechteam.com/',
    preview: '',
  },
  // {
  //   name: 'Table tennis ball tracking',
  //   image: TableTennis,
  //   description:
  //     'Table tennis ball tracking by TTNet',
  //   stack: ['Python', 'Pytorch', 'TTNet', 'CNN'],
  //   code: 'https://github.com/cutupdev/Table-Tennis-Ball-Tracking-using-CNN/',
  //   online: 'https://www.harmonitechteam.com/',
  //   preview: ''
  // },
]

const skills = [
  'Smart Contact',
  'Web3',
  'Rust',
  'Anchor',
  'Go',
  'Solidity',
  'JavaScript',
  'TypeScript',
  'Node.js',
  'Django',
  'MongoDB',
  'PostgreSQL',
  'ChromaDB',
  'AI',
  'LLM',
  'React',
  'Next.js',
  'TailwindCSS',
  'Git',
  'Docker',
  'AWS',
]

const contact = {
  email: 'devcutup@gmail.com',
}

export { header, about, projects, skills, contact }
